import React from "react";
import { format } from "date-fns";
import { ITableModel } from "components/Table/interface";
import { Button } from "components/Button";
import { IUnansweredRow } from "./UnansweredItemsDetailDropdown";

const COLUMN_TEXT_MAX_WIDTH = 233;
const COLUMN_C_CLIENTE_WIDTH = 117;

function CellNoWrap({ value }: { value: string | undefined }) {
  const text = value ?? "-";
  return (
    <span
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
        maxWidth: "100%",
      }}
      title={text}
    >
      {text}
    </span>
  );
}

export function unansweredTableModel(
  onOpenQuotation: (row: IUnansweredRow) => void
): ITableModel[] {
  return [
    {
      label: "",
      key: "blockedQuote",
      size: 20,
      maxSize: 20,
      noFilter: true,
    },
    {
      label: "Cotação",
      key: "code",
      size: 100,
      maxSize: 100,
      noFilter: true,
      Component: (data: IUnansweredRow) => (
        <Button
          width="100%"
          className="text-left color-primary w-100"
          style={{ minWidth: 0 }}
          onClick={() => onOpenQuotation(data)}
        >
          <CellNoWrap value={data.code} />
        </Button>
      ),
    },
    {
      label: "Criação",
      key: "createdAt",
      size: 105,
      maxSize: 105,
      type: "date",
      noFilter: true,
      Component: (data: IUnansweredRow) => {
        const text = data.createdAt
          ? format(new Date(data.createdAt), "dd/MM/yyyy' às 'HH:mm")
          : "-";
        return (
          <Button
            width="auto"
            className="text-left text-wrap color-primary"
            style={{ minWidth: 105, maxWidth: 105 }}
            onClick={() => onOpenQuotation(data)}
          >
            {text}
          </Button>
        );
      },
    },
    {
      label: "C. Cliente",
      key: "customerName",
      size: COLUMN_C_CLIENTE_WIDTH,
      maxSize: COLUMN_C_CLIENTE_WIDTH,
      noFilter: true,
      Component: (data: IUnansweredRow) => (
        <Button
          width="auto"
          className="text-left justify-start color-primary"
          style={{ minWidth: COLUMN_C_CLIENTE_WIDTH, maxWidth: COLUMN_C_CLIENTE_WIDTH }}
          onClick={() => onOpenQuotation(data)}
        >
          <CellNoWrap value={data.customerName} />
        </Button>
      ),
    },
    {
      label: "Razão Social",
      key: "razaoSocial",
      size: COLUMN_TEXT_MAX_WIDTH,
      maxSize: COLUMN_TEXT_MAX_WIDTH,
      noFilter: true,
      Component: (data: IUnansweredRow) => {
        const text = data.razaoSocial ?? data.customerName ?? "-";
        return (
          <Button
            width="auto"
            className="text-left justify-start color-primary"
            style={{ minWidth: COLUMN_TEXT_MAX_WIDTH, maxWidth: COLUMN_TEXT_MAX_WIDTH }}
            onClick={() => onOpenQuotation(data)}
          >
            <span
              title={text}
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical" as const,
                overflow: "hidden",
                wordBreak: "break-word",
              }}
            >
              {text}
            </span>
          </Button>
        );
      },
    },
    {
      label: "Categoria",
      key: "category",
      size: 140,
      maxSize: 140,
      noFilter: true,
      Component: (data: IUnansweredRow) => (
        <Button
          width="100%"
          className="text-center color-primary w-100"
          style={{ minWidth: 140, maxWidth: 140 }}
          onClick={() => onOpenQuotation(data)}
        >
          <span style={{ display: "block", textAlign: "center" }}>
            <CellNoWrap value={data.category} />
          </span>
        </Button>
      ),
    },
    {
      label: "Qtd",
      key: "qtd",
      size: 50,
      maxSize: 50,
      noFilter: true,
      Component: (data: IUnansweredRow) => (
        <Button
          width="auto"
          className="text-left color-primary"
          style={{ minWidth: 50, maxWidth: 50 }}
          onClick={() => onOpenQuotation(data)}
        >
          {data.qtd ?? "-"}
        </Button>
      ),
    },
    {
      label: "Status da cotação",
      key: "statusDescription",
      size: 160,
      maxSize: 160,
      noFilter: true,
      Component: (data: IUnansweredRow) => (
        <Button
          width="auto"
          className="text-left color-primary"
          style={{ minWidth: 160, maxWidth: 160 }}
          onClick={() => onOpenQuotation(data)}
        >
          <CellNoWrap value={data.statusDescription} />
        </Button>
      ),
    },
    {
      label: "Expira em",
      key: "expiresAt",
      size: 135,
      maxSize: 135,
      type: "date/hour",
      noFilter: true,
      Component: (data: IUnansweredRow) => {
        const text = data.expiresAt
          ? format(new Date(data.expiresAt), "dd/MM/yyyy' às 'HH:mm")
          : "-";
        return (
          <Button
            width="auto"
            className="text-left text-wrap justify-start color-primary"
            style={{ minWidth: 135, maxWidth: 135 }}
            onClick={() => onOpenQuotation(data)}
          >
            {text}
          </Button>
        );
      },
    },
    {
      label: "Origem",
      key: "origin",
      size: 90,
      maxSize: 90,
      noFilter: true,
      Component: (data: IUnansweredRow) => (
        <Button
          width="100%"
          className="text-center color-primary w-100"
          style={{ minWidth: 90, maxWidth: 90 }}
          onClick={() => onOpenQuotation(data)}
        >
          <span style={{ display: "block", textAlign: "center" }}>
            <CellNoWrap value={data.origin} />
          </span>
        </Button>
      ),
    },
  ];
}
